"use strict";

angular.module("vendor")
.service("DiscountService", function($resource, appConfig) {
    var discountTypesResource = $resource(appConfig.API_SERVER + "/catalog/vendor/discount/discount-types/");
    var discountResource = $resource(appConfig.API_SERVER + "/catalog/vendor/discount/:id/", {
        id: "@id"
    }, {
        delete: {
            method: "DELETE"
        }
    });

    this.queryDiscountTypes = function() {
        return discountTypesResource.query();
    };

    this.delete = function(discount) {
        return discountResource.delete({
            id: discount.id
        });
    }
});



//////////////////
// WEBPACK FOOTER
// ./vendor/sections/catalog/catalog-entry-tab/catalog-entry-discount/discount.service.js
// module id = 881
// module chunks = 0